// images
import img1 from '../images/service/1.jpg'
import img2 from '../images/service/2.jpg'
import img3 from '../images/service/3.jpg'
import img4 from '../images/service/2.jpg'


import icon1 from '../images/service/icon-1.svg'
import icon2 from '../images/service/icon-2.svg'
import icon3 from '../images/service/icon-3.svg'
import icon4 from '../images/service/icon-4.svg'
import icon5 from '../images/service/icon-3.svg'


/* Single image */
import simg1 from '../images/service-single/img-1.jpg'
import simg2 from '../images/service-single/img-2.jpg'
import simg3 from '../images/service-single/img-3.jpg'
import simg4 from '../images/service-single/img-4.jpg'
import simg5 from '../images/service-single/img-5.jpg'
import simg6 from '../images/service-single/img-6.jpg'
import simg7 from '../images/service-single/img-7.jpg'
import simg8 from '../images/service-single/img-8.jpg'
import simg9 from '../images/service-single/img-9.jpg'
import simg10 from '../images/service-single/img-5.jpg'
import simg11 from '../images/service-single/img-6.jpg'
import simg12 from '../images/service-single/img-7.jpg'
import simg13 from '../images/service-single/img-8.jpg'
import simg14 from '../images/service-single/img-9.jpg'




const Services = [
    {
        id: 1,
        image: img1,
        icon: 'flaticon-fund',
        simage: simg1,
        title: 'Supporting Orphaned Children',
        subtitle: 'Find information for people with dis',
        description: 'Supporting orphaned children with care and education.',
        slug: 'Fund-Raised-&-Donation'
    },
    {
        id: 2,
        image: img2,
        icon: 'flaticon-first-aid-kit', 
        simage: simg2,
        title: 'Supporting Oladge People',
        subtitle: 'Find information for people with dis',
        description: 'Supporting the elderly with dignity and compassion.',
        slug: 'Medical-Treatment-Help'
    },
    {
        id: 3,
        image: img3,
        icon: 'flaticon-charity',
        simage: simg3,
        title: 'Advancement of Education',
        subtitle: 'Find information for people with dis',
        description: 'Promoting the advancement of education for all.',
        slug: 'development-programs'
    },
    {
        id: 4,
        image: img4,
        icon: 'flaticon-cardiogram',
        simage: simg4,
        title: 'Relief of Poverty',
        subtitle: 'Find information for people with dis',
        description: 'Providing relief to people living in poverty.',
        slug: 'Child-medical-research'
    },
    {
        id: 5,
        image: img2,
        icon: 'flaticon-gift-box',
        simage: simg5,
        title: 'Corporate Gifts donate',
        subtitle: 'Find information for people with dis',
        description: 'Sagittis fringilla a scelerisque sitro consetetur nunc. Urna est eget pellentesque.',
        slug: 'Corporate-Gifts-donate'
    },
    {
        id: 6,
        image: img2,
        icon: 'flaticon-graduation-cap',
        simage: simg6,
        title: 'We Educate & help poor people',
        subtitle: 'Find information for people with dis',
        description: 'Transmax is the world trwe uphold industry Customer Oriented',
        slug: 'Corporate-Gifts-donate6'
    },
    {
        id: 7,
        image: img2,
        icon: 'flaticon-charity',
        simage: simg7,
        title: 'Corporate Gifts donate',
        subtitle: 'Find information for people with dis',
        description: 'Transmax is the world trwe uphold industry Customer Oriented',
        slug: 'Corporate-Gifts-donate7'
    },
    {
        id: 8,
        image: img2,
        icon: 'flaticon-checklist',
        simage: simg8,
        title: 'Corporate Gifts donate',
        subtitle: 'Find information for people with dis',
        description: 'Transmax is the world trwe uphold industry Customer Oriented',
        slug: 'Corporate-Gifts-donate8'
    },
    {
        id: 9,
        image: img2,
        icon: 'flaticon-medal',
        simage: simg9,
        title: 'Corporate Gifts donate',
        subtitle: 'Find information for people with dis',
        description: 'Transmax is the world trwe uphold industry Customer Oriented',
        slug: 'Corporate-Gifts-donate9'
    },
    {
        id: 10,
        image: icon1,
        icon: 'flaticon-medal',
        simage: simg10,
        title: 'They get new home',
        subtitle: 'Find information for people with dis',
        description: 'With over 1 million+ homes for sale availableon the website, Trulia can match you with a house you will want to call home.',
        slug: 'Corporate-Gifts-donate10'
    },
    {
        id: 11,
        image: icon2,
        icon: 'flaticon-medal',
        simage: simg11,
        title: 'Veterinary Helping',
        subtitle: 'Find information for people with dis',
        description: 'With over 1 million+ homes for sale availableon the website, Trulia can match you with a house you will want to call home.',
        slug: 'Corporate-Gifts-donate11'
    },
    {
        id: 12,
        image: icon3,
        icon: 'flaticon-medal',
        simage: simg12,
        title: 'Make Pets Happy',
        subtitle: 'Find information for people with dis',
        description: 'With over 1 million+ homes for sale availableon the website, Trulia can match you with a house you will want to call home.',
        slug: 'Corporate-Gifts-donate12'
    },
    {
        id: 13,
        image: icon4,
        icon: 'flaticon-medal',
        simage: simg13,
        title: 'Cargo Ship Freight',
        subtitle: 'Find information for people with dis',
        description: 'With over 1 million+ homes for sale availableon the website, Trulia can match you with a house you will want to call home.',
        slug: 'Corporate-Gifts-donate13'
    },
    {
        id: 14,
        image: icon5,
        icon: 'flaticon-medal',
        simage: simg14,
        title: 'Natural healthy Food',
        subtitle: 'Find information for people with dis',
        description: 'With over 1 million+ homes for sale availableon the website, Trulia can match you with a house you will want to call home.',
        slug: 'Corporate-Gifts-donate14'
    },
  

];
export default Services;